import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchLessonModules } from "../../api/lesson_modules/teachers";

import TeacherReaderSidebar from "../../components/TeacherReaderSidebar";
import { TeacherReaderWidgets } from "./TeacherReaderWidgets";
import { useDropdown } from '../../hooks/useDropdown';

import { SignedInDropdown } from "../../components/Navbar/SignedInDropdown"
import { getCookie, setCookie } from '../../utils';

import "./index.css";
import logoSrc from "../../images/Profile-Default.png"

import { Button } from "../../components/Shared/Button"
import { fetchCourse } from "../../api/courses/teachers";

function BackIcon() {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.7072 13.7929C9.09772 14.1834 9.09772 14.8166 8.7072 15.2071C8.31668 15.5976 7.68351 15.5976 7.29299 15.2071L1.50009 9.41421C0.719046 8.63317 0.719044 7.36684 1.50009 6.58579L7.29299 0.792894C7.68351 0.402369 8.31668 0.402369 8.7072 0.792894C9.09772 1.18342 9.09772 1.81658 8.7072 2.20711L3.91431 7H18.0001C18.5524 7 19.0001 7.44772 19.0001 8C19.0001 8.55229 18.5524 9 18.0001 9H3.91431L8.7072 13.7929Z" fill="#131313"/>
    </svg>
  )
}

function TeacherReaderNavbar() {
  const ref = useRef();
  const navigate = useNavigate();
  const [loggedIn, _] = useState(getCookie("jwtToken").length > 0);
  const [showDropdown, setShowDropdown] = useDropdown(ref);

  const { lessonId } = useParams();
  
  useEffect(() => {
    if (!loggedIn) {
      navigate("/")
      setCookie("jwtToken", "")
    }
  }, [loggedIn])

  return (
    <div className="TractusNavbar">
      <div className="EmployeeReaderNavbarBackBtnContainer">
        <Button
          text="Back"
          color="white"
          Icon={() => <BackIcon />}
          onClick={() => navigate(`/teacher/lessons/${lessonId}/edit`)}
        />
      </div>
      <div style={{ position: "relative" }}>
        <div
          style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <div
            className="TractusNavbarProfileImg"
            style={{ backgroundImage: `url("${logoSrc}")` }}
          />
          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29294 0.333374C9.71219 0.333374 9.94528 0.81834 9.68337 1.14572L5.39035 6.512C5.19019 6.7622 4.80965 6.7622 4.60948 6.512L0.316463 1.14572C0.0545568 0.818339 0.287644 0.333374 0.706898 0.333374L9.29294 0.333374Z" fill="#131313"/>
          </svg>
        </div>

        {showDropdown &&
          <div ref={ref}>
            <SignedInDropdown />
          </div>
        }
      </div>
    </div>
  )
}

function TeacherLessonModules() {
  const { pathname } = useLocation();
  const { lessonId } = useParams();
  const [lessonModules, setLessonModules] = useState({});
  const [course, setCourse] = useState(null);
  
  useEffect(async () => {
    try {
      const res = await fetchLessonModules(lessonId);
      setLessonModules(res);
      if (!course) {
        const courseRes = await fetchCourse(res.lesson.course_id);
        setCourse(courseRes);
      }
    } catch (err) {
      console.log(err)
    }
  }, [pathname]);

  return (
    <>
      <div className="ReaderCourseTitleContainer">
        <div className="ReaderCourseTitleBtn">
          Course title
        </div>

        <div className="ReaderCourseTitle">{course && course.title}</div>
        <div className="ReaderCourseTitleAuthorContainer">
          <div className="ReaderCourseTitleAuthorImgContainer">
            <div
              className="ReaderCourseTitleAuthorImg"
              style={{ backgroundImage:`url(${course && course.author_profile_image_url})` }}
            />
          </div>

          <div className="ReaderCourseTitleAuthorInfo">
            <div className="ReaderCourseTitleAuthorName">By {course && course.author_name}</div>
            <div className="ReaderCourseTitleAuthorTitle">Author</div>
          </div>
        </div>
      </div>
      <TeacherReaderWidgets {...lessonModules} />
    </>
  )
}

function TeacherReader() {
  return (
    <>
      <TeacherReaderNavbar />
      <div className="TeacherReaderContainer">
        <div className="TeacherReaderSidebarContainer">
          <TeacherReaderSidebar />
        </div>
        <div className="TeacherReaderModulesContainer">
          <TeacherLessonModules />
        </div>
      </div>
    </>
  )
}

export default TeacherReader;
